import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-component p-formgrid p-grid p-input-filled p-mt-2" }
const _hoisted_2 = { class: "p-fluid p-field p-col-9" }
const _hoisted_3 = { for: "id" }
const _hoisted_4 = { class: "p-field p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_FilterListForm = _resolveComponent("FilterListForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Squeeze.UserManagement.DocumentClass")) + ": ", 1),
        _createVNode(_component_Dropdown, {
          id: "id",
          modelValue: _ctx.filterListEntryDropdown,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterListEntryDropdown) = $event)),
          options: _ctx.fullFilterList,
          onChange: _ctx.onChangeValueList,
          loading: _ctx.loading,
          placeholder: _ctx.$t('Squeeze.UserManagement.NoFilters'),
          optionLabel: _ctx.getDocumentClassDescription
        }, null, 8, ["modelValue", "options", "onChange", "loading", "placeholder", "optionLabel"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { style: {"width":"100%"} }, " ", -1)),
        _withDirectives(_createVNode(_component_Button, {
          type: "button",
          icon: "mdi mdi-plus",
          class: "p-button p-ml-2",
          label: _ctx.fullFilterList.length === 0 ? _ctx.$t('Squeeze.UserManagement.CreateFilter') : null,
          onClick: _ctx.openNewEntry
        }, null, 8, ["label", "onClick"]), [
          [_directive_tooltip, _ctx.$t('Squeeze.UserManagement.CreateFilter')]
        ]),
        (_ctx.fullFilterList.length > 0)
          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
              key: 0,
              type: "button",
              icon: "mdi mdi-delete",
              class: "p-button p-ml-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteDialog = true))
            }, null, 512)), [
              [_directive_tooltip, _ctx.$t('Squeeze.UserManagement.DeleteFilter')]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveValueListItem,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_FilterListForm, {
              documentClasses: _ctx.filterDocumentClasses(_ctx.documentClasses),
              filterRole: _ctx.filterListEntry,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage
            }, null, 8, ["documentClasses", "filterRole", "onUpdate", "showErrorMessage"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText"])
  ], 64))
}